import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from "vue-cookies";

/**
 * Export configured axios instance to avoid passing "backendUrl" and authorization token everywhere
 *
 * Use this instead, like so:
 *
 * import axios from '@/axios'
 *
 * axios().get('/some-url').then(...)
 * no need to add api url at the beginning nor header { Authorization ... }
 */

export default () => {
    const axiosConfig = {
        baseURL: backendUrl(),
        timeout: 10000,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "bearer " +  vuecookie.get('token')
        },
        params: {},
    };

    return axios.create(axiosConfig);
}
